// Component imports
import EventClinicConfirmationTab from './EventClinicConfirmationTab'
import CompetitorEventRegisterWrapper from '../../CompetitorEventRegisterWrapper'

import { IRegistrationEventTab } from '../../../../types/competitor_types'

type ClinicNOtherEventRegisterConfirmationTabProps = {
  title?: string
  description?: string
  activeTab: IRegistrationEventTab
  setEventTab: (eventTab: IRegistrationEventTab) => void
  setIsSplitBill: (value: boolean) => void
  isSplitBill: boolean
}

const ClinicNOtherEventRegisterConfirmationTab = (
  props: ClinicNOtherEventRegisterConfirmationTabProps
) => {
  return (
    <CompetitorEventRegisterWrapper title={props.title} description={props.description}>
      <EventClinicConfirmationTab
        activeTab={props.activeTab}
        setEventTab={props.setEventTab}
        setIsSplitBill={props.setIsSplitBill}
        isSplitBill={props.isSplitBill}
      />
    </CompetitorEventRegisterWrapper>
  )
}

export default ClinicNOtherEventRegisterConfirmationTab
